import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { ArrowLeft, Scale, Building, FileText, AlertTriangle } from "lucide-react";

export default function LegalNotice() {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 font-mono text-sm text-zinc-500 hover:text-primary transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          VOLVER
        </Link>

        <div className="bg-[#111] border border-zinc-800 p-8">
          <div className="flex items-center gap-3 mb-8">
            <Scale className="w-8 h-8 text-primary" />
            <h1 className="text-3xl font-black tracking-tighter">
              AVISO <span className="text-primary">LEGAL</span>
            </h1>
          </div>

          <p className="text-zinc-400 mb-8 font-mono text-sm">
            Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>

          {/* Identificación */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <Building className="w-5 h-5 text-primary" />
              1. DATOS IDENTIFICATIVOS
            </h2>
            <div className="text-zinc-400 space-y-2">
              <p>En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI-CE), se informa:</p>
              <div className="bg-[#0a0a0a] border border-zinc-800 p-4 mt-4">
                <ul className="space-y-2">
                  <li><strong className="text-zinc-300">Denominación social:</strong> ROCKMAPS</li>
                  <li><strong className="text-zinc-300">Nombre comercial:</strong> Rockmaps</li>
                  <li><strong className="text-zinc-300">Domicilio:</strong> Barcelona, España</li>
                  <li><strong className="text-zinc-300">Email de contacto:</strong> info@rockmaps.es</li>
                  <li><strong className="text-zinc-300">Sitio web:</strong> https://rockmaps.es</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Objeto y ámbito */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <FileText className="w-5 h-5 text-primary" />
              2. OBJETO Y ÁMBITO DE APLICACIÓN
            </h2>
            <div className="text-zinc-400 space-y-2">
              <p>
                El presente Aviso Legal regula el acceso y uso del sitio web rockmaps.es (en adelante, "el Sitio Web"), 
                una plataforma dedicada a:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
                <li>Promoción de bares y locales de música rock</li>
                <li>Difusión de eventos y conciertos</li>
                <li>Conexión entre bares, bandas y aficionados a la música</li>
              </ul>
              <p className="mt-4">
                El acceso al Sitio Web atribuye la condición de Usuario e implica la aceptación plena 
                y sin reservas de todas las disposiciones incluidas en este Aviso Legal.
              </p>
            </div>
          </section>

          {/* Condiciones de uso */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4">3. CONDICIONES DE USO</h2>
            <div className="text-zinc-400 space-y-4">
              <p>El Usuario se compromete a:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Hacer un uso adecuado de los contenidos y servicios ofrecidos</li>
                <li>No realizar actividades ilícitas o contrarias a la buena fe</li>
                <li>No difundir contenidos de carácter racista, xenófobo, pornográfico o que atenten contra los derechos humanos</li>
                <li>No introducir virus informáticos o realizar acciones que dañen los sistemas</li>
                <li>No intentar acceder a cuentas de otros usuarios</li>
                <li>Proporcionar información veraz en los formularios de registro</li>
              </ul>
              
              <div className="bg-yellow-500/10 border border-yellow-500/30 p-4 mt-4">
                <p className="text-yellow-400 font-mono text-sm">
                  El incumplimiento de estas condiciones podrá dar lugar a la retirada del acceso 
                  al Sitio Web sin previo aviso.
                </p>
              </div>
            </div>
          </section>

          {/* Propiedad intelectual */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4">4. PROPIEDAD INTELECTUAL E INDUSTRIAL</h2>
            <div className="text-zinc-400 space-y-2">
              <p>
                Todos los contenidos del Sitio Web (textos, imágenes, logos, código fuente, diseño gráfico) 
                son propiedad de ROCKMAPS o de terceros que han autorizado su uso, y están protegidos 
                por las leyes de propiedad intelectual e industrial.
              </p>
              <p className="mt-2">
                Queda prohibida la reproducción, distribución, transformación o comunicación pública 
                de los contenidos sin autorización expresa.
              </p>
              <p className="mt-2">
                Los contenidos publicados por los usuarios (descripciones de bares, eventos, imágenes) 
                son responsabilidad de cada usuario, quien garantiza tener los derechos necesarios 
                para su publicación.
              </p>
            </div>
          </section>

          {/* Exclusión de garantías */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
              <AlertTriangle className="w-5 h-5 text-primary" />
              5. EXCLUSIÓN DE GARANTÍAS Y RESPONSABILIDAD
            </h2>
            <div className="text-zinc-400 space-y-4">
              <p>ROCKMAPS no se hace responsable de:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>La falta de disponibilidad, continuidad o calidad del servicio</li>
                <li>Errores u omisiones en los contenidos publicados por terceros</li>
                <li>Daños derivados del uso indebido del Sitio Web</li>
                <li>La veracidad de la información proporcionada por los usuarios</li>
                <li>Eventos cancelados o modificados por los organizadores</li>
                <li>Problemas de seguridad derivados de vulnerabilidades del navegador del usuario</li>
              </ul>
              
              <div className="bg-[#0a0a0a] border border-zinc-800 p-4 mt-4">
                <p className="text-zinc-300 font-bold mb-2">Sobre los eventos publicados:</p>
                <p className="text-sm">
                  ROCKMAPS actúa como plataforma de difusión. La responsabilidad sobre la 
                  celebración, condiciones y desarrollo de los eventos corresponde exclusivamente 
                  a los organizadores (bares y bandas).
                </p>
              </div>
            </div>
          </section>

          {/* Enlaces externos */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4">6. ENLACES EXTERNOS</h2>
            <div className="text-zinc-400 space-y-2">
              <p>
                El Sitio Web puede contener enlaces a páginas externas (redes sociales, venta de entradas, 
                webs de bares). ROCKMAPS no se responsabiliza del contenido, políticas de privacidad 
                o prácticas de dichos sitios externos.
              </p>
            </div>
          </section>

          {/* Modificaciones */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4">7. MODIFICACIONES</h2>
            <div className="text-zinc-400 space-y-2">
              <p>
                ROCKMAPS se reserva el derecho de modificar en cualquier momento la presentación, 
                configuración y contenidos del Sitio Web, así como las condiciones requeridas para 
                su acceso y uso.
              </p>
            </div>
          </section>

          {/* Legislación aplicable */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-white mb-4">8. LEGISLACIÓN APLICABLE Y JURISDICCIÓN</h2>
            <div className="text-zinc-400 space-y-2">
              <p>
                Las presentes condiciones se rigen por la legislación española. Para cualquier 
                controversia que pudiera derivarse del acceso o uso del Sitio Web, las partes 
                se someten a los Juzgados y Tribunales de Barcelona, renunciando a cualquier 
                otro fuero que pudiera corresponderles.
              </p>
            </div>
          </section>

          {/* Contacto */}
          <section>
            <h2 className="text-xl font-bold text-white mb-4">9. CONTACTO</h2>
            <div className="text-zinc-400">
              <p>
                Para cualquier consulta relacionada con este Aviso Legal, puede contactar con 
                nosotros a través de:{" "}
                <a href="mailto:info@rockmaps.es" className="text-primary hover:underline">
                  info@rockmaps.es
                </a>
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
